var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"download-modal",on:{"click":_vm.closeModal,"touchmove":function($event){$event.preventDefault();}}},[_c('div',{staticClass:"download-modal-container"},[_c('div',{staticClass:"title"},[_vm._v("打开快音，享受更多功能互动与体验。")]),_c('button',{staticClass:"btn",attrs:{"id":"downloadBtn"},on:{"click":_vm.openApp}},[_vm._v("打开/下载快音")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }